enum TtlEnum {
  TenSeconds = 10,
  FifteenSeconds = 15,
  ThirtySeconds = 30,
  OneMinute = 60,
  TwoMinutes = 120,
  ThreeMinutes = 180,
  FiveMinutes = 300,
  TenMinutes = 600,
  FifteenMinutes = 900,
  ThirtyMinutes = 1800,
  OneHour = 3600,
  OneDay = 86400,
  OneWeek = 604800,
  NinetyDays = 7776000,
  OneYear = 31536000,
}

export default TtlEnum
